'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSenderPairs = undefined;

var _immutable = require('immutable');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var getSenderPairs = exports.getSenderPairs = function getSenderPairs(threadHistory) {
  if (!threadHistory || !(0, _getMessages.getMessages)(threadHistory)) {
    return (0, _immutable.Set)();
  }
  return (0, _getMessages.getMessages)(threadHistory).reduce(function (responders, message) {
    if ((0, _messageTypeComparators.isChatMessage)(message) || (0, _messageTypeComparators.isInitialMessage)(message)) {
      var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);
      var senderType = (0, _commonMessageFormatGetters.getSenderType)(message);
      var responder = (0, _immutable.Map)({ senderId: senderId, senderType: senderType });
      if (senderId && (senderType === _senderTypes.AGENT || senderType === _senderTypes.BOT)) {
        return responders.add(responder);
      }
    }
    return responders;
  }, (0, _immutable.Set)());
};